// @flow

import API from 'api/OutboundAffiliatesAPI';

export const getOutboundAffiliates = () => {
  return (dispatch: any) => {
    dispatch({ type: 'FETCH_USER_SPECIALDEALS' });
    return API.getOutboundAffiliates().then(res => {
      dispatch(outboundAffiliatesSuccess(res.data));
    }).catch(res => {
      dispatch(outboundAffiliatesFailure(res));
    });
  }
};

export const setActiveOutboundAffiliate = (affiliate: Object) => {
  return { type: 'SET_ACTIVE_OUTBOUND_AFFILIATE_CATEGORY', payload: affiliate };
}

export const outboundAffiliatesSuccess = (data: any) => {
  return { type: 'FETCH_OUTBOUND_AFFILIATES_SUCCESS', payload: data };
};

export const outboundAffiliatesFailure = (error: any) => {
  return { type: 'FETCH_OUTBOUND_AFFILIATES_FAILURE', payload: error };
};



// WEBPACK FOOTER //
// ./src/actions/outboundAffiliates/index.js